import { TaskProps } from "./tasks_types"
import { ProjectProps } from "./project_types"
import { RFIProps } from "./rfi_types"
import { SubmittalProps } from "./submittal_types"
import { AssignmentProps } from "./assignment_types"
import { LucideIcon } from "lucide-react"

export type Roles = "Administrator" | "Manager" | "Team Member" | "Accountant" |
    "CEO" | "Mechanical Head" | "Electrical Head" | "Plumbing Head" | "Fire Protection Head" |
    "IT" | "IT Head" | "Other" | "Client"

export const RoleHierarchy = {
    'ADMIN': ['Administrator'],
    'CEO': ['CEO'],
    'IT': ['IT Head', 'IT'],
    'MANAGERS': ['CEO', 'Mechanical Head', 'Electrical Head', 'Plumbing Head', 'Fire Protection Head', 'IT', 'IT Head', 'Manager'],
    'TEAM': ['Team Member'],
    'FINANCE': ['Accountant'],
    'CLIENT': ['Client'],
    'OTHER': ['Other']
}

// For the employee creation form
// Exclude the Administrator and CEO roles as they are not used in the employee creation form
export const EMPLOYEE_ROLES = [
    "Mechanical Head",
    "Electrical Head",
    "Plumbing Head",
    "Fire Protection Head",
    "IT",
    "IT Head",
    "Manager",
    "Team Member",
    "Accountant",
    "Other",
    "Client"
]

export type EmployeeProps = {
    id?: string,
    name: string,
    email: string,
    username: string,
    password: string,
    role: Roles,
    date_joined?: string,
    projects?: ProjectProps[]
    tasks?: TaskProps[] 
    RFIs?: RFIProps[]
    submittals?: SubmittalProps[]
    preferences?: EmployeePreferences
    assignments?: AssignmentProps[]
    resource_manager?: boolean
    nav_bar_items?: NavBarItems
}

export type NavBarItems = {
    user: {
        name: string
        email: string
        role: string
    }
    teams: {
        name: string
        logo: string | LucideIcon
        plan: string
    }[]
    navMain: {
        title: string
        url: string
        icon?: string | LucideIcon
        isActive?: boolean
        openInNewWindow?: boolean
        openInNewTab?: boolean
        additionalWindows?: {
            url: string
            title: string
        }[] // Used to open additional windows (Mainly used for the Project Reports page)
        items?: {
            title: string
            url: string
        }[]
    }[]
}


export type EmployeePreferences = {
    [key: string]: string | number | boolean | string[] | null
}

export type EmployeeNameEmail = {
    name: string
    email: string

    // Used for dropdowns (if for_selection is true)
    value: string
    label: string
}

export type EmployeeFormProps = {
    id?: string
    name: string
    email: string
    username: string
    role: Roles
}
